import axios from "../axios";
// 条件查询书籍列表
export const getBookList = (data) => {
  return axios({
    url: "/con/custom/book/getBookList",
    method: "GET",
    data,
  });
};
// 更新书籍状态
export const updateStatus = (data) => {
  return axios({
    url: "/con/custom/book/updateStatus",
    method: "GET",
    data,
  });
};
// 创建书本
export const addBook = (data) => {
  return axios({
    url: "/con/custom/book/addBook",
    method: "GET",
    data,
  });
};
// 编辑书本
export const updateBook = (data) => {
  return axios({
    url: "/con/custom/book/updateBook",
    method: "GET",
    data,
  });
};
// 查看题目列表
export const getQuestionList = (data) => {
  return axios({
    url: "/con/manage/question/catalogQuestions",
    method: "GET",
    data,
  });
};
// 编辑创建目录
export const editBookMenu = (data) => {
  return axios({
    url: "/con/custom/book/updateBookCatalog",
    method: "GET",
    data,
  });
};
// 获取书本详情
export const getBookDetail = (data) => {
  return axios({
    url: "/con/custom/book/getBookDetail",
    method: "GET",
    data,
  });
};
// 添加题目
export const addQuestion = (data) => {
  return axios({
    url: "/con/manage/question/addQuestion",
    method: "POST",
    data,
  });
};
// 查看题目
export const viewQuestion = (data) => {
  return axios({
    url: "/con/manage/question/getQuestionById",
    method: "GET",
    data,
  });
};

// 编辑题目
export const editQuestion = (data) => {
  return axios({
    url: "/con/manage/question/edit",
    method: "POST",
    data,
  });
};



// WEBPACK FOOTER //
// ./src/http/moudules/academicBooks.js